module.exports = __webpack_public_path__ + "static/media/noa_tote_front.e295eeaa.png";